// extracted by mini-css-extract-plugin
export default {"tagCloudPicker":"_2uIcBtvO","input":"_1Ps0gb6u","tag":"_2JNSdGl8"};